// My Quotes loader (GW-470) — lazy-loads the direct-mount My-Quotes widget bundle.
//
// GW builds a dedicated storefront CORE "My Quotes" page (its own header/footer)
// and drops:
//     <div data-pf-quotes></div>
// This tiny storefront.js widget injects the self-contained React IIFE
// (public/js/quotes-widget.js, CSS inlined), which mounts the quote list DIRECTLY
// into the div — no iframe (the storefront sends `X-Frame-Options: deny`). Same
// mechanism as the log-return form loader; the heavy React bundle only loads on
// pages that actually carry the marker.
import { getTopDocument } from '../shared/dom.js';
import { getAppBaseUrl, getApiKey, QUOTES_ENABLED } from '../shared/config.js';

export var id = 'quotes-list';

var WIDGET_FLAG = '__pfQuotesWidgetInjected';

export function init() {
  // GW-470 kill-switch: don't load/mount the My-Quotes widget when quotes are off
  // (generate-quote-button.js hides the [data-pf-quotes] marker via CSS).
  if (!QUOTES_ENABLED) return;
  var doc = getTopDocument();
  var markers = doc.querySelectorAll('[data-pf-quotes]');
  if (!markers || markers.length === 0) return;

  var win = doc.defaultView || window;

  // Publish config the widget's SPA api client resolves from (client.ts reads
  // these globals first): app base URL for '/api' + the machine key fallback.
  try {
    if (!win.__PARTS_FINDER_APP_BASE_URL__) win.__PARTS_FINDER_APP_BASE_URL__ = getAppBaseUrl();
    if (!win.__PARTS_FINDER_API_KEY__) win.__PARTS_FINDER_API_KEY__ = getApiKey();
  } catch (e) { /* non-fatal */ }

  if (win[WIDGET_FLAG]) {
    try { if (win.PartsFinderQuotes && win.PartsFinderQuotes.autoMount) win.PartsFinderQuotes.autoMount(); } catch (e) { /* ignore */ }
    return;
  }
  win[WIDGET_FLAG] = true;

  var src = getAppBaseUrl() + 'js/quotes-widget.js';
  var s = doc.createElement('script');
  s.src = src;
  s.async = true;
  s.onload = function () {
    try { if (win.PartsFinderQuotes && win.PartsFinderQuotes.autoMount) win.PartsFinderQuotes.autoMount(); } catch (e) { /* ignore */ }
  };
  s.onerror = function () {
    win[WIDGET_FLAG] = false;
    try { console.error('[parts-finder] failed to load quotes widget bundle from ' + src); } catch (e) { /* ignore */ }
  };
  (doc.head || doc.getElementsByTagName('head')[0] || doc.body).appendChild(s);
}
